import React, { Component } from 'react';
import withStyles from '@material-ui/styles/withStyles';
import { withRouter } from 'react-router-dom';
import Grid from '@material-ui/core/Grid';
import { Table, TableHead, TableBody, TableCell, TableRow } from '@material-ui/core';
import RoomSharpIcon from '@material-ui/icons/RoomSharp';

import Topbar from '../common/Topbar';
import Footer from '../common/Footer';
import TitleText from '../common/TitleText';
import { API_URL, optionsCity } from '../common/Constants';

import GoogleMapReact from 'google-map-react';
import axios from 'axios';

import Select from 'react-select';

const StyledTableCell = withStyles((theme) => ({
  head: {
    padding: '8px 16px',
    fontSize: '1rem',
    //borderRadius: '30px',
    borderBottomStyle: 'none',
    backgroundColor: theme.palette.primary.main,
  },
  body: {
    fontSize: '1rem',
    borderBottom: '1px solid rgba(0, 0, 0, 0.1)',
  },
}))(TableCell);

const styles = (theme) => ({
  bg: {
    width: '100%',
    // height: 'calc(100vh - 85px)',
    overflowX: 'hidden',
    overflowY: 'auto',
    backgroundColor: '#fafafa',
  },
  content_bg: {
    backgroundColor: '#ffffff',
    margin: '4vh auto',
    width: '100%',
    borderRadius: '20px',
  },
  urlMobile: {
    display: 'none',
    textAlign: 'center',
    [theme.breakpoints.down('md')]: {
      display: 'table-cell',
    },
  },
  urlWeb: {
    display: 'table-cell',
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },
});

const AnyReactComponent = ({ text, link }) => (
  <div
    style={{ cursor: 'pointer' }}
    onClick={() => {
      window.open(link, '_blank');
    }}
  >
    <RoomSharpIcon style={{ color: '#CA5A48' }} />
  </div>
);

const TextComponent = ({ text, link }) => (
  <div
    style={{
      cursor: 'pointer',
      width: '100px',
      minWidth: '50px',
      background: '#FFFFFF',
      borderRadius: '3px',
      padding: '3px',
      textAlign: 'center',
      marginTop: '-20px',
    }}
    onClick={() => {
      window.open(link, '_blank');
    }}
  >
    <div>{text}</div>
  </div>
);

class TourMap extends Component {
  // {  lat: 59.95, lng: 30.33, },
  static defaultProps = {
    center: { lat: 36.4630589, lng: 127.875158 },
    /*
    placeCoords: [
      { lat: 37.5630589, lng: 126.975158 },
      // { lat: 59.724465, lng: 30.080121 },
      // { lat: 59.95, lng: 30.080121 },
    ],
    */
    zoom: 7,
  };

  constructor(props) {
    super(props);
    this.state = {
      now: new Date(),
      value: 0,
      matches: window.matchMedia('(max-width:600px)').matches,
      courseList: [],
      originList: [],
      hoverKey: null,
    };
    this.handleChange = this.handleChange.bind(this);
  }

  componentDidMount() {
    axios.get(`${API_URL}/course/list`, { headers: { Pragma: 'no-cache' } }).then((res) => {
      // console.log('COMPONENT DID MOUNT');

      res.data.sort((a, b) => {
        if (b.name > a.name) return -1;
        else if (b.name < a.name) return 1;
        else return 0;
      });

      if (res.data) {
        this.setState({
          courseList: res.data.filter((data) => data.lng && data.lat),
          originList: res.data.filter((data) => data.lng && data.lat),
        });
      }
    });
  }

  handleChange(event, newValue) {
    this.setState({ value: newValue });
    // console.log(this.state.value);
  }

  onClickMap(param) {
    // console.log(param);
  }

  onChildMouseEnter(key, prop) {
    // console.log(key);
    // console.log(prop);
    this.setState({ hoverKey: prop.id });
  }
  onChildMouseLeave(key, prop) {
    // console.log(key);
    this.setState({ hoverKey: null });
    // console.log(prop);
  }

  render() {
    const { classes } = this.props;

    return (
      <React.Fragment>
        <Topbar />
        <div className={classes.bg}>
          <Grid item xs={10} className={classes.content_bg}>
            <TitleText title="대한민국 스탬프투어" />
            <div style={this.state.matches ? { padding: ' 0' } : { padding: '0px 10vw' }}>
              <Grid container spacing={3} style={{ paddingBottom: '30px' }}>
                <Grid item xs={12}>
                  <div style={{ height: '50vh', width: '100%' }}>
                    <GoogleMapReact
                      bootstrapURLKeys={{ key: 'AIzaSyAZjrcfrfMHdOCn8za5Vy9ht_fdrH7Vd5Q' }}
                      defaultCenter={this.props.center}
                      defaultZoom={this.props.zoom}
                      center={this.state.center}
                      onClick={this.onClickMap}
                      onChildClick={this.onClickMap}
                      onChildMouseEnter={(key, prop) => {
                        this.onChildMouseEnter(key, prop);
                      }}
                      onChildMouseLeave={(key, prop) => {
                        this.onChildMouseLeave(key, prop);
                      }}
                    >
                      {/*facilityPins*/}
                      {this.state.courseList.map((data) => {
                        return <AnyReactComponent lat={data.lat} lng={data.lng} text={data.name} id={data.id} link={data.link} />;
                      })}
                      {this.state.courseList.map((data) => {
                        return this.state.hoverKey === data.id ? (
                          <TextComponent lat={data.lat} lng={data.lng} text={data.name} id={data.id} link={data.link} />
                        ) : null;
                      })}
                    </GoogleMapReact>
                  </div>
                </Grid>

                <Grid item xs={12}>
                  <div style={{ marginBottom: '10px' }}>
                    <Select
                      options={optionsCity}
                      isClearable={true}
                      placeholder={'지역을 선택해 주세요'}
                      onChange={(param1, param2) => {
                        // console.log(param1);
                        // console.log(param2);

                        if (param1) {
                          this.setState({ courseList: this.state.originList.filter((data) => data.region === param1.value) });
                        } else {
                          this.setState({ courseList: this.state.originList });
                        }
                      }}
                    />
                  </div>
                  <Table>
                    <TableHead>
                      <TableRow>
                        <StyledTableCell width="30%" align="center" style={{ borderRadius: '30px 0 0 30px' }}>
                          <span style={{ fontWeight: 'bold', color: '#ffffff' }}>이름</span>
                        </StyledTableCell>
                        <StyledTableCell width="40%" align="center" style={{ maxWidth: '40%' }}>
                          <span style={{ fontWeight: 'bold', color: '#ffffff' }}>소재지</span>
                        </StyledTableCell>
                        <StyledTableCell width="30%" align="center" style={{ borderRadius: '0 30px 30px 0' }}>
                          <span style={{ fontWeight: 'bold', color: '#ffffff' }}>관련 URL</span>
                        </StyledTableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {this.state.courseList.map((course, cIdx) => {
                        return (
                          <TableRow key={`table-row-${cIdx}`}>
                            <TableCell
                              align="center"
                              key={`table-cell-1-${cIdx}`}
                              onClick={() => {
                                // console.log(course.id);
                                this.setState({ center: { lat: course.lat, lng: course.lng, hoverKey: course.id } });
                              }}
                              style={{ cursor: 'pointer' }}
                            >
                              {course.name}
                            </TableCell>
                            <TableCell
                              align="center"
                              key={`table-cell-2-${cIdx}`}
                              onClick={() => {
                                this.setState({ center: { lat: course.lat, lng: course.lng, hoverKey: course.id } });
                              }}
                              style={{ cursor: 'pointer' }}
                            >
                              {course.addr}
                            </TableCell>
                            <TableCell key={`table-cell-3-mobile-${cIdx}`} className={classes.urlMobile}>
                              <a href={course.link} target="_blank" rel="noreferrer">
                                살펴보기
                              </a>
                            </TableCell>
                            <TableCell key={`table-cell-3-web-${cIdx}`} className={classes.urlWeb}>
                              <a href={course.link} target="_blank" rel="noreferrer">
                                {course.link}
                              </a>
                            </TableCell>
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  </Table>
                </Grid>
              </Grid>
            </div>
          </Grid>
        </div>
        <Footer />
      </React.Fragment>
    );
  }
}
export default withRouter(withStyles(styles, { withTheme: true })(TourMap));
